import { useEffect, useState, useRef } from "react";
import WorkspaceIcon from '../../../assets/images/svg-icons-material-io/workspaces_FILL0_wght400_GRAD0_opsz48.svg';
import MailboxIcon from '../../../assets/images/svg-icons-material-io/local_post_office_FILL0_wght400_GRAD0_opsz48.svg';
import MailFwdIcon from '../../../assets/images/svg-icons-material-io/forward_to_inbox_FILL0_wght400_GRAD0_opsz48.svg';
import { Link, useNavigate } from "react-router-dom";
import $ from "jquery";

const SubMenuModal = () => {
    const navigate = useNavigate();
    const [flag, setFlag] = useState(false);
    const firstLinkRef = useRef(null);

    useEffect(() => {
        if (flag) {
            CloseModal();
            navigate(flag, { replace: true })
        };
    }, [flag, navigate]);

    useEffect(() => {
        const modalEl = document.getElementById("UserReportSubMenu");
        if (!modalEl) return;
        const onShown = () => {
            setTimeout(() => firstLinkRef.current?.focus(), 50);
        };
        modalEl.addEventListener("shown.bs.modal", onShown);
        return () => modalEl.removeEventListener("shown.bs.modal", onShown);
    }, []);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $('#UserReportSubMenu').modal('hide');
    };
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape" && $("#UserReportSubMenu").hasClass("show")) {
                CloseModal();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);

    return (
        <div className="SubMenuModal">
        <div
            className="modal fade"
            data-backdrop="static"
            tabIndex="-1"
            role="dialog"
            id="UserReportSubMenu"
            aria-labelledby="userReportSubMenuTitle"
            aria-modal="true"
            aria-describedby="userReportSubMenuDesc"
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <button
                            type="button"
                            className="close"
                            aria-label="Close User Reports Menu"
                            onClick={CloseModal}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body ctr animate slide delay-1">
                        <p id="userReportSubMenuDesc" className="sr-only">
                            Select a report type to navigate to that section.
                      </p>
                        <Link
                            onClick={(el) => { setFlag("/user-activity"); }}
                            className="btn btn-primary dash-box box-user-activity"
                            aria-label="User Activity Reports"
                            ref={firstLinkRef}
                        >
                            <div className="box-icon" aria-hidden="true">
                                <img src={WorkspaceIcon} className="filter-white" alt="" />
                            </div>
                            <div className="box-bottom" aria-hidden="true">
                                <div className="title">User Activity</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                        
                        <Link
                            onClick={(el) => { setFlag("/delete-user-activity"); }}
                            className="btn btn-primary dash-box box-delect-activity"
                            aria-label="Delete Activity Reports"
                        >
                            <div className="box-icon" aria-hidden="true">
                                <i className="bi bi-trash"></i>
                            </div>
                            <div className="box-bottom" aria-hidden="true">
                                <div className="title">Delete Activity</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                        
                        <Link
                            onClick={(el) => { setFlag("/mailbox-size"); }}
                            className="btn btn-primary dash-box box-mailbox"
                            aria-label="Mailbox Sizes Reports"
                        >
                            <div className="box-icon" aria-hidden="true">
                                <img src={MailboxIcon} className="filter-white" alt="" />
                            </div>
                            <div className="box-bottom" aria-hidden="true">
                                <div className="title">Mailbox Sizes</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link >

                        <Link
                            onClick={(el) => { setFlag("/user-status"); }}
                            className="btn btn-primary dash-box box-userstatus"
                            aria-label="User Status Reports"
                        >
                            <div className="box-icon" aria-hidden="true">
                                <i className="bi bi-clipboard2-data"></i>
                            </div>
                            <div className="box-bottom" aria-hidden="true">
                                <div className="title">User Status</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link >

                        <Link
                            onClick={(el) => { setFlag("/message-forwarding"); }}
                            className="btn btn-primary dash-box box-msgfwd"
                            aria-label="Message Forwarding Reports"
                        >
                            <div className="box-icon" aria-hidden="true">
                                <img src={MailFwdIcon} className="filter-white" alt="" />
                            </div>
                            <div className="box-bottom" aria-hidden="true">
                                <div className="title">Message Forwarding</div>
                                <div className="sub-title">Reports</div>
                            </div>
                        </Link>
                    </div >
                </div >
            </div >
        </div >
        </div>
    )
};




export default SubMenuModal;